import { ImagemLogo } from "../../components/imagensDinamicas"

function PageNotFound(){
    return(
        <div className="h-screen w-screen justify-center items-center flex flex-col">
            <div className="w-full flex justify-center">
                <ImagemLogo/>
            </div>
            <div className="grid justify-center text-center font-bold w-full">
                <h1 className="text-xl">Página Não Encontrada : (</h1>
                <h1 className="text-xl">404</h1>
                <h3 className="text-blue-500 text-lg"><a href="/">Clique aqui para voltar à página inicial</a></h3>
            </div>
        </div>
    )
}

export default PageNotFound